import { useProcessScholarsRequestMutation } from "../../../services/graphql/api";
import { getScholarsApplDetailParams } from "../ScholarsApplicant";
import MenuDialogBase from "./MenuDialogBase";
import { STUDENT_REQUEST_ACTIONS } from "../../../util/constants";

// Only handles Program Change (Approve/Deny), and Withdraw (Approve/Cancel)
export default function DialogBase({ menuItemAndClose, requestType, isApproved = false, }) {
  const [apiCall, result] = useProcessScholarsRequestMutation();

  const variablesFn = () => {
    const { applicantEmployeeId, term } = getScholarsApplDetailParams();
    const applicantEmployeeIds = [applicantEmployeeId];
    
    return { applicantEmployeeIds, term, requestType, isApproved, }
  };

  const buttons = [{ label: "Submit", apiCall, result, variablesFn }];
  const extraContent = <></>;
  
  // Must massage because of the lambda response format necessary for Program Change report
  let resultMassaged = JSON.parse(JSON.stringify(result ?? {}));
  if (resultMassaged.data?.status === "success") { resultMassaged.data.status = resultMassaged.data.successDetails; }
  if (resultMassaged.data?.status === "error") { resultMassaged.isError = true; resultMassaged.error = {}; }

  return (
    <MenuDialogBase menuItemAndClose={menuItemAndClose}
      apiCall={apiCall}
      buttons={buttons} 
      result={resultMassaged ?? result}
      extraContent={extraContent}
    />
  );
}

export function DialogProgramChangeApprove({ menuItemAndClose }) {
    return DialogBase({ menuItemAndClose, requestType: STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.KEY, isApproved: true });
}

export function DialogProgramChangeDeny({ menuItemAndClose }) {
    return DialogBase({ menuItemAndClose, requestType: STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.KEY, isApproved: false });
}

export function DialogWithdrawApprove({ menuItemAndClose }) {
    return DialogBase({ menuItemAndClose, requestType: STUDENT_REQUEST_ACTIONS.WITHDRAW.KEY, isApproved: true });
}

export function DialogWithdrawCancel({ menuItemAndClose }) {
    return DialogBase({ menuItemAndClose, requestType: STUDENT_REQUEST_ACTIONS.WITHDRAW.KEY, isApproved: false });
}